import React from 'react';
import { Section } from '../layout/Section';
import { Icon } from '../ui/Icon';




/**
 * ReviewsSection Component
 * 
 * Displays Google Reviews for the restaurant with average rating,
 * individual review cards, and a link to write a new review.
 * 
 * Falls back to demo reviews when no API key is configured.
 * 
 * Requirements:
 * - 5.1: Display a selection of Google Reviews on the website
 * - 5.2: Display a "Bewertung schreiben" button
 * - 5.3: Link to Google Reviews page
 * - 5.4: Display at least the 3 most recent reviews
 * - 5.5: Show reviewer name, rating, and review text
 * - 5.6: Display the average rating prominently
 */
export const ReviewsSection: React.FC = () => {
  const writeReviewUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent('Restaurant Fey Tibarg Hamburg')}`;

  return (
    <Section
      id="bewertungen"
      variant="dark"
      aria-labelledby="reviews-heading"
    >
      {/* Section Header */}
      <div className="text-center mb-12">
        <h2
          id="reviews-heading"
          className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4"
        >
          Bewertungen
        </h2>
        <div className="w-24 h-1 bg-[#c9a84c] mx-auto rounded-full" aria-hidden="true" />
      </div>

      {/* Coming soon info box */}
      <div className="max-w-xl mx-auto text-center">
        <div className="bg-[#242424] rounded-xl p-8 flex flex-col items-center gap-5">
          {/* Stars decorative */}
          <div className="flex items-center gap-1" aria-hidden="true">
            {Array.from({ length: 5 }, (_, i) => (
              <Icon key={i} name="star" size={28} className="text-[#c9a84c]" decorative />
            ))}
          </div>

          <p className="text-white text-lg font-medium">
            Google Bewertungen werden bald hier angezeigt.
          </p>
          <p className="text-gray-400 text-sm leading-relaxed">
            Wir sind gerade frisch gestartet – sobald unsere Google-Seite aktiviert ist,
            erscheinen hier die echten Bewertungen unserer Gäste.
          </p>

          {/* Write review CTA */}
          <a
            href={writeReviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center px-8 py-3 rounded-lg font-semibold text-base bg-[#c9a84c] text-[#1a1a1a] hover:bg-[#b8963e] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#c9a84c] focus:ring-offset-2 focus:ring-offset-[#1a1a1a]"
            aria-label="Bewertung auf Google schreiben (öffnet in neuem Tab)"
          >
            Jetzt als Erster bewerten
          </a>
        </div>
      </div>
    </Section>
  );
};
